export default __webpack_public_path__ + "static/media/AvertaStdCY-Bold.dc489422.otf";